module.exports = __webpack_public_path__ + "img/spam.1d1a2920.svg";